import { css } from "@emotion/react";
import { Theme } from "@mui/material/styles";

export const styles = {
  button: (theme: Theme) =>
    css({
      transition: "border 0ms",
      backgroundClip: "padding-box, border-box",
      backgroundOrigin: "border-box",
      borderRadius: "20px",
      border: `solid 1px ${theme.palette.divider}`,
      color: theme.palette.common.white,
      minWidth: "200px",
      padding: "7px 16px",

      "&:hover": {
        border: "1px solid transparent",
        boxShadow: "none",
      },

      ".MuiButton-startIcon": {
        marginLeft: 0,

        ".MuiSvgIcon-root": {
          fontSize: "24px",
        },
      },
    }),
  buttonBackground: (theme: Theme) =>
    css({
      borderRadius: "20px",
      marginLeft: "12px",
      minWidth: "200px",
      backgroundImage: "none",
      backgroundSize: "auto",

      "&:hover": {
        backgroundImage:
          theme.palette.mode === "dark"
            ? "radial-gradient(circle at bottom right, #358BCA, #36EDB9)"
            : "none",
      },
    }),
  buttonText: (theme: Theme) =>
    css({
      fontWeight: theme.typography.fontWeightSemiBold,
      fontFamily: theme.typography.fontFamily,
    }),
  iconButton: (theme: Theme) =>
    css({
      color: theme.palette.mode === "light" ? "default" : "primary",

      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    }),
};
